import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  align-items: center;
  column-gap: ${({ theme }) => theme.space.s050};
`
